import type { FunctionComponent } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/legacy-i18n';
import { Spinner } from '@trello/nachos/spinner';
import type { AppManagementTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { usePluginOrganizationOwnerQuery } from '../queries/PluginOrganizationOwnerQuery.generated';
import { MemberList } from './MemberList';

import styles from './PowerUpCollaboratorsPage.less';

const format = forTemplate('app_management');

export const PowerUpCollaboratorsPage: FunctionComponent<{
  idPlugin: string;
}> = ({ idPlugin }) => {
  const { data, error, loading } = usePluginOrganizationOwnerQuery({
    variables: {
      idPlugin,
    },
    waitOn: ['None'],
  });

  if (error) {
    return <div>{format('something-went-wrong')}</div>;
  }

  const plugin = data?.plugin;

  if (loading || !plugin) {
    return (
      <div className={styles.spinnerContainer}>
        <Spinner
          testId={getTestId<AppManagementTestIds>(
            'power-up-collaborators-page-spinner',
          )}
        />
      </div>
    );
  }

  const { idOrganizationOwner } = plugin;

  Analytics.sendScreenEvent({
    name: 'powerUpAdminCollaboratorsScreen',
    containers: {
      organization: { id: idOrganizationOwner },
    },
    attributes: { idPlugin },
  });

  return (
    <>
      <div className={styles.header}>
        <h1>{format('collaborators')}</h1>
      </div>
      <div>
        <p>{format('collaborators-description')}</p>
        <p>
          {format('collaborators-contact')}
          <a
            target="_blank"
            className={styles.learnMoreSubtle}
            rel="noopener noreferrer"
            href="https://community.developer.atlassian.com/t/power-up-developers-changes-in-the-way-we-communicate-with-you/79361"
          >
            {' '}
            {format('collaborators-learn-more')}
          </a>
        </p>
      </div>
      <MemberList
        idPlugin={idPlugin}
        idOrganizationOwner={idOrganizationOwner}
      />
    </>
  );
};
